/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".date-picker-trigger[_ngcontent-%COMP%]{display:inline-block;float:inline-end;height:0}label[_ngcontent-%COMP%]{width:100%}input[_ngcontent-%COMP%]{width:90%}[_nghost-%COMP%]{width:9em!important}.fa-calendar-day[_ngcontent-%COMP%]{color:#cfcfcf;font-size:12px}"];
export { styles as styles };
